var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
/**
 * One distinct unpriceable-skip-reason bucket inside the preview.
 *
 * `reason` is the German UI string the spine reader already produces
 * (`skipReasonFor`) — there is one bucket per distinct reason. `count` is
 * the number of treatment units that would be skipped for that reason if
 * the run were started right now.
 */
export class InvoiceRunSkipReasonCountDto {
    reason;
    count;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], InvoiceRunSkipReasonCountDto.prototype, "reason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], InvoiceRunSkipReasonCountDto.prototype, "count", void 0);
/**
 * Response of `GET /v1/office-locations/:officeLocationId/invoice-run/preview`.
 *
 * **Counts-only** preview the UI shows before the operator commits. Nothing
 * is persisted — the reader + grouper produce the snapshot used here and
 * the actual command call later may see a different snapshot (eligibility
 * drift between preview and execute is accepted; the worker re-validates
 * per item). No priced preview in v1.
 *
 *  - `invoiceCount`: number of consolidation groups the run would create
 *    (one group = one planned invoice).
 *  - `patientCount`: distinct patients across `eligible[]`.
 *  - `skipCount`: number of unpriceable units the reader would skip.
 *  - `skipReasons`: per-reason buckets (German labels, descending count).
 */
export class InvoiceRunPreviewResponseDto {
    invoiceCount;
    patientCount;
    skipCount;
    skipReasons;
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], InvoiceRunPreviewResponseDto.prototype, "invoiceCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], InvoiceRunPreviewResponseDto.prototype, "patientCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], InvoiceRunPreviewResponseDto.prototype, "skipCount", void 0);
__decorate([
    Expose(),
    Type(() => InvoiceRunSkipReasonCountDto),
    __metadata("design:type", Array)
], InvoiceRunPreviewResponseDto.prototype, "skipReasons", void 0);
//# sourceMappingURL=invoice-run-preview.response.dto.js.map